<template>
  <div class="org-projects">
    <ul
      v-if="data && Object.keys(data).length"
      class="clearfix"
    >
      <li class="item">
        <div class="item-top clearfix">
          <span class="project-name fl">询盘管理项目</span>
          <a-switch
            :checked="!!data.xg.switch"
            @change="onChangeSwitch($event, 'xg')"
          />
        </div>
        <p class="intro-text">
          用于集中管理企业询盘，可以完整记录询盘的上、中、下游信息，实时统计各环节的工作人员排行和渠道效果，实现询盘开发人员、接待人员、跟进人员的协作。
        </p>
        <div class="bottom">
          当前项目数量：{{ data.xg.num }}
        </div>
      </li>
      <li class="item">
        <div class="item-top">
          <span class="project-name">会员管理项目</span>
          <a-switch
            :checked="!!data.mc.switch"
            @change="onChangeSwitch($event, 'mc')"
          />
        </div>
        <p class="intro-text">
          用于集中管理所有和企业有关系的人员，可以从询盘管理项目直接同步创建会员，也可以导入或者对接其他来源，采集会员动态，进行会员精细化管理。
        </p>
        <div class="bottom">
          当前项目数量：{{ data.mc.num }}
        </div>
      </li>
      <li class="item">
        <div class="item-top">
          <span class="project-name">广告回传项目</span>
          <a-switch
            :checked="!!data.realback.switch"
            @change="onChangeSwitch($event, 'ad')"
          />
        </div>
        <p class="intro-text">
          用于向广告平台回传准确的转化数据，目前面向的场景是以加微信作为最终转化的方式。
        </p>
        <div class="bottom">
          当前项目数量：{{ data.realback.num }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'OrgProjects',
  data () {
    return {
      data: {}
    }
  },
  computed: {
    ...mapState('orgProjectsSet', ['orgProjectData']),
    cid () {
      return this.$route.query.cid
    }
  },
  async mounted () {
    let chain = await this.getProjectType({
      cid: this.cid
    })
    chain.onSuccess(() => {
      this.data = { ...this.orgProjectData }
    })
  },
  methods: {
    ...mapActions('orgProjectsSet', ['getProjectType', 'setProjectType']),

    async onChangeSwitch (val, type) {
      let paramsType = ''
      let title = ''
      if (type === 'xg') {
        paramsType = 1
        title = '询盘管理项目'
      } else if (type === 'mc') {
        paramsType = 2
        title = '会员管理项目'
      } else if (type === 'ad') {
        paramsType = 3
        title = '广告回传项目'
      }
      let chain = await this.setProjectType({
        cid: this.cid,
        type: paramsType // 1、2、3（1星轨、2会员、3广告回传）
      })
      chain.onNetSuccess((res = {}) => {
        const { error, message } = res.data
        if (error === 100 && message) {
          this.switchFail(message, title)
        }
      }).onSuccess(() => {
        switch (type) {
          case 'xg':
            this.data.xg.switch = val
            break
          case 'mc':
            this.data.mc.switch = val
            break
          case 'ad':
            this.data.realback.switch = val
            break
        }
      })
    },
    switchFail (message, title) {
      this.$confirm({
        title: '不能关闭' + title,
        content: message,
        closable: true,
        okText: this.$t('message["1276"]'), // '我知道了'
        cancelText: this.$t('message["896"]'), // '取消'
        class: 'confirm-warn-modal knew-modal'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.org-projects {
  width: 1198px;
}
.item {
  float: left;
  width: 330px;
  height: 171px;
  margin:0 24px 24px 3px;
  padding: 25px 24px 2px;
  box-sizing: content-box;
  box-shadow: 0 2px 4px 0 #eceff1;
  border: solid 1px #eceff1;
  background-color: #fff;
  border-radius: 4px;
  &:last-child {
    margin-right: 0;
  }
}
.item-top {
  height: 22px;
  line-height: 22px;
  .ant-switch {
    float: right;
  }
}
.intro-text {
  margin: 16px 0;
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
</style>
